import { createSelector } from "reselect";

export const getModalState = createSelector(
  [state => state.modal],
  modalState => modalState || {},
);
